module.exports = __webpack_public_path__ + "static/media/logo-bco.ce53a5ff.svg";